import {
  CLEAR_QUERY_STRINGS,
  SET_QRY_STR_MEDIUM,
  SET_QRY_STR_SOURCE,
  SET_QRY_STR_MODE,
  SET_QRY_STR_DEVICE,
  SET_QRY_STR_TCP_MIDDELWARE_ADDR,
  SET_QRY_STR_TCP_MIDDELWARE_PORT,
} from "./queryStringsTypes";

const initialState = {
  medium: "",
  source: "",
  mode: "",
  device: "",
  NodeAppIP: "",
  NodeAppPort: "",
};

const queryStringReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_QRY_STR_MEDIUM:
      return { ...state, medium: action.payload };
    case SET_QRY_STR_SOURCE:
      return { ...state, source: action.payload };
    case CLEAR_QUERY_STRINGS:
      return { ...initialState };
    case SET_QRY_STR_MODE:
      return { ...state, mode: action.payload };
    case SET_QRY_STR_DEVICE:
      return { ...state, device: action.payload };
    case SET_QRY_STR_TCP_MIDDELWARE_ADDR:
      return { ...state, NodeAppIP: action.payload };
    case SET_QRY_STR_TCP_MIDDELWARE_PORT:
      return { ...state, NodeAppPort: action.payload };
    default:
      return state;
  }
};

export default queryStringReducer;
